export const env = {
  BASE_URL: '/hucopia',
  BACKEND: 'https://bioinfo.usu.edu/hbe'
}
